import { useFlags } from 'launchdarkly-react-client-sdk';
import { Flags } from '@setvi/shared/enums';
import { useSingerLabel } from 'hooksv2';

/**
 * Singer on "RFQ Quotes V1" gets a single-user experience: when the QuotesV2
 * flag is OFF, the Auto RFQ flag is ON, and the logged-in user's company is
 * Singer, the collaboration features (presence pile, per-row avatars, edit
 * locks, follow) and the Internal Share action are hidden from the RFQ.
 *
 * Silent cross-user item sync (`SilentSyncBridge`) is intentionally left on —
 * it needs no Ably Space and isn't part of the visible collaboration UI.
 */
export const useRfqCollabDisabled = (): boolean => {
  const flags = useFlags();
  const { isSinger } = useSingerLabel();

  return isSinger && !flags?.[Flags.QUOTES_V2] && !!flags?.[Flags.AUTO_RFQ];
};
